import React from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import Label from 'components/ui/Label';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { isValidEmail, isValidLoyaltyNumber } from 'utils/validators';
import { LOYALTY_NUMBER_PREFIX } from 'constants/passengers';

import {
  StyledInput,
  ErrorField,
  Field,
  StyledSubmitField,
  StyledForm,
  MembershipNumberPrefix,
  MembershipNumberInput,
  MembershipNumberInputWrapper
} from './ManageClubEurostar.styles';

const SearchCustomerForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState, watch, setValue } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      membershipNumber: '',
      email: ''
    }
  });

  const { errors } = formState;

  const values = watch();
  const isSubmitDisabled = Object.keys(errors).length > 0 || !Object.keys(values).find((key) => !!values[key]);
  const reformatMembershipNumber = (e) => {
    setValue('membershipNumber', e.target.value.replace('308381100', ''));
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <Label htmlFor="membershipNumber">
          <FormattedMessage id="paxForm.loyaltyNumber" />
        </Label>
        <MembershipNumberInputWrapper>
          <MembershipNumberPrefix>{LOYALTY_NUMBER_PREFIX}</MembershipNumberPrefix>
          <MembershipNumberInput>
            <StyledInput
              {...register('membershipNumber', {
                validate: (value) => !value || isValidLoyaltyNumber(value),
                onChange: (e) => reformatMembershipNumber(e)
              })}
              type="number"
              inputmode="numeric"
              id="membershipNumber"
              maxLength="8"
              validationState={errors.membershipNumber ? 'error' : ''}
            />
          </MembershipNumberInput>
        </MembershipNumberInputWrapper>
        {errors.membershipNumber && (
          <ErrorField id="error-membership-number">
            <FormattedMessage id="clubEurostar.membershipNumberValidationMessage" />
          </ErrorField>
        )}
      </Field>
      <Field>
        <Label htmlFor="email">
          <FormattedMessage id="paxForm.email" />
        </Label>
        <StyledInput
          {...register('email', {
            validate: (value) => !value || isValidEmail(value)
          })}
          type="text"
          inputMode="email"
          id="email"
          validationState={errors.email ? 'error' : ''}
        />
        {errors.email && (
          <ErrorField id="error-email">
            <FormattedMessage id="clubEurostar.emailValidationMessage" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="customer-search" type="submit" disabled={isSubmitDisabled}>
          <FormattedMessage id="clubEurostar.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchCustomerForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchCustomerForm;
